import type { ListRobotQrsResponse, IssueRobotQrResponse, RobotQrDto } from '@bhops/shared';
import { apiClient } from './client';

export const robotQrsApi = {
  async list(robotId: string): Promise<ListRobotQrsResponse> {
    const { data } = await apiClient.get<ListRobotQrsResponse>(`/robots/${robotId}/qrs`);
    return data;
  },
  async issue(robotId: string): Promise<IssueRobotQrResponse> {
    const { data } = await apiClient.post<IssueRobotQrResponse>(`/robots/${robotId}/qrs/issue`);
    return data;
  },
  async revoke(robotId: string, qrId: string, reason?: string): Promise<RobotQrDto> {
    const { data } = await apiClient.post<RobotQrDto>(`/robots/${robotId}/qrs/${qrId}/revoke`, {
      reason,
    });
    return data;
  },
};
